// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"AddPaymentModal_tooltip__6ReBJ","root":"AddPaymentModal_root__KC7bl","label":"AddPaymentModal_label___EcVQ","input":"AddPaymentModal_input__fYmmV"};